import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Badge } from "./ui/badge";
import { resolveImg } from "../services/api";

const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/product/${product.id}`}
      className="group block bg-white rounded-xl overflow-hidden border border-neutral-100 card-lift"
    >
      <div className="relative aspect-square overflow-hidden bg-neutral-100">
        <img
          src={resolveImg(product.image)}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover img-zoom"
        />
        {product.tags?.length > 0 && (
          <Badge className="absolute top-3 left-3 bg-[#C9A227] text-white hover:bg-[#C9A227] border-0">
            {product.tags[0]}
          </Badge>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
          <span className="inline-flex items-center gap-1.5 text-white text-sm font-semibold">
            View Details <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </div>
      <div className="p-4">
        <div className="text-[11px] uppercase tracking-wider text-[#C9A227] font-bold mb-1">
          {product.subcategory}
        </div>
        <h3 className="font-display font-bold text-[15px] text-[#14171c] leading-snug group-hover:text-[#C9A227] transition-colors line-clamp-2">
          {product.name}
        </h3>
        <div className="mt-2 flex items-center justify-between text-xs text-neutral-500">
          <span>{product.moq}</span>
          <span>{product.leadTime}</span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
